//@ts-ignore
import moengage from '@moengage/web-sdk'

import getFeatureFlag from '../actions/get-feature-flag'

export enum MOENGAGE_EVENT_NAME {
  VIEW_ONBOARDING = 'view_onboarding',
  VIEW_REGISTER = 'view_register',
  VIEW_LOGIN = 'view_login',
  SUBMIT_REGISTER_INFORMATION = 'submit_register_information',
  SUBMIT_LOGIN_INFORMATION = 'submit_login_information',
  VIEW_SURVEY_LIST = 'view_survey_list',
  VIEW_SURVEY_DETAIL = 'view_survey_detail',
  START_SURVEY = 'start_survey',
  COMPLETE_SURVEY = 'complete_survey',
  VIEW_SUBMISSION_HISTORY = 'view_submission_history',
  VIEW_CLAIM_REWARDS = 'view_claim_rewards',
  VERIFY_REGISTER_PHONE_NUMBER = 'verify_register_phone_number',
  RESEND_REGISTER_PHONE_NUMBER_OTP = 'resend_register_phone_number_otp',
  VIEW_ACCOUNT_CREATED_CONFIRMATION = 'view_account_created_confirmation',
  CREATE_REGISTER_PIN = 'create_register_pin',
  VERIFY_REGISTER_PIN = 'verify_register_pin',
  VIEW_SUCCESS_CREATE_PIN_CONFIRMATION = 'view_success_create_pin_confirmation',
}

export enum MoengageUserProperty {
  ADD_USER_NAME = 'add_user_name',
  ADD_UNIQUE_USER_ID = 'add_unique_user_id',
  ADD_MOBILE = 'add_mobile',
  ADD_EMAIL = 'add_email',
}

const isMoengageEnabled = async (): Promise<boolean> => {
  return await getFeatureFlag('enableMoengage')
}

export const setMoengageAttributeOnce = async (property: MoengageUserProperty, value: string) => {
  const moengageEnabled = await isMoengageEnabled()

  if (moengageEnabled) {
    moengage[property](value)
  }
}

export const destroyMoengageSession = async () => {
  const moengageEnabled = await isMoengageEnabled()

  if (moengageEnabled) {
    moengage.destroy_session()
  }
}

export const trackMoengageEvent = async (
  eventName: MOENGAGE_EVENT_NAME,
  attributes?: Record<string, string>,
) => {
  const moengageEnabled = await isMoengageEnabled()

  if (moengageEnabled) {
    moengage.track_event(eventName, { ...attributes })
  }
}
